export const queryKeys = {
  categories: ["categories"] as const,
  customer: (id: string) => ["customers", id] as const,
  customers: ["customers"] as const,
  invoice: (id: string) => ["invoice", id] as const,
  kitchenDay: (date: string) => ["kitchen", "day", date] as const,
  kitchenPacking: (date: string) => ["kitchen", "packing", date] as const,
  kitchenPrep: (date: string) => ["kitchen", "prep", date] as const,
  lots: ["lots"] as const,
  order: (id: string) => ["orders", id] as const,
  orders: (filters: Record<string, string>) => ["orders", filters] as const,
  product: (id: string) => ["products", id] as const,
  products: (filters: Record<string, string>) => ["products", filters] as const,
  stock: ["stock"] as const,
  workOrder: (id: string, date: string) => ["work-order", id, date] as const,
}
